import React, { useState } from 'react';
import { OptionCard } from './OptionCard';
import { SelectPartnersModal } from './SelectPartnersModal';

const primaryOptions = [
  {
    icon: "📊",
    title: "Create a New Media Plan",
    description: "Develop and execute your media strategy"
  },
  {
    icon: "📋",
    title: "Create a Tactical Plan",
    description: "Plan and execute tactical campaigns"
  },
  {
    icon: "🤝",
    title: "View Deals",
    description: "View deals, preferred partners and blacklisted partners",
    link: "/partners/display/deals"
  }
];

export function LandingPage() {
  const [showPartnersModal, setShowPartnersModal] = useState(false);
  
  const handlePartnerOptionClick = (e) => {
    e.preventDefault();
    setShowPartnersModal(true);
  };

  const secondaryOptions = [
    {
      icon: "📱",
      title: "Select and Optimize Channels",
      description: "Choose and configure your media channels",
      link: "/channels",
      inProgress: true
    },
    {
      icon: "🤝",
      title: "Select and Optimize Partners",
      description: "Choose and optimize your media partners",
      onClick: handlePartnerOptionClick,
      inProgress: true
    },
    {
      icon: "📈",
      title: "View Insights",
      description: "Analyze past performance and gain valuable insights"
    },
    {
      icon: "⚙️",
      title: "Configuration Settings",
      description: "Customize your workspace and preferences"
    }
  ];

  return (
    <main className="main-content">
      <h1 className="page-title">What would you like to do?</h1>
      
      <div className="options-grid">
        {primaryOptions.map((option, index) => (
          <OptionCard 
            key={index}
            icon={option.icon}
            title={option.title}
            description={option.description}
            link={option.link}
            inProgress={option.inProgress}
          />
        ))}
      </div>

      <h2 className="page-title" style={{ marginTop: '3rem' }}>Dive straight in</h2>
      
      <div className="options-grid">
        {secondaryOptions.map((option, index) => (
          <OptionCard 
            key={index}
            icon={option.icon}
            title={option.title}
            description={option.description}
            link={option.link}
            onClick={option.onClick}
            inProgress={option.inProgress}
          />
        ))}
      </div>

      {showPartnersModal && (
        <SelectPartnersModal onClose={() => setShowPartnersModal(false)} />
      )}
    </main>
  );
} 